<template>
  <div>
    <div class="desktop_profile">
      <main-profile-scholar :idScholar="id" />
    </div>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="pa-2">
          <!-- <v-card class="rounded-lg pa-3 mb-3" flat>
            <div class="d-flex align-center mb-3">
              <v-icon color="var(--g)" class="mr-3">
                mdi-information-outline
              </v-icon>
              <h5>Announcement:</h5>
            </div>
            <div class="d-flex align-start" v-if="announ.length">
              <v-carousel
                v-model="model"
                height="150"
                hide-delimiters
                show-arrows-on-hover
              >
                <v-carousel-item v-for="(item, i) in announ" :key="i">
                  <div @click="viewAnouncement(item)" class="cursor">
                    <h3 class="text-center mb-3" v-snip="2">
                      {{ item.title }}
                    </h3>
                    <div class="d-flex align-start">
                      <v-icon class="mr-3" color="var(--g)">
                        mdi-circle-small
                      </v-icon>
                      <h5
                        v-if="item.description"
                        v-html="item.description"
                        v-snip="3"
                      ></h5>
                      <h5 v-else>No Description</h5>
                    </div>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </div>
            <div
              class="d-flex align-center justify-center"
              style="height: 150px"
              v-else
            >
              <h3>No announcements for now</h3>
            </div>
          </v-card> -->
          <!-- RADAR SCHOLAR -->
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <!-- Your Current Level -->
            <div>
              <v-card class="rounded-lg pa-3 d-flex justify-center" flat>
                <v-row align="center" no-gutters justify="center">
                  <v-col  cols="12" md="12" lg="4">
                    <div class="txt-current-phase">
                      <img
                        src="../../../../assets/img/radar/IconScholar.png"
                        height="35px"
                        alt=""
                      />
                      <h3 class="ml-2">Your Current Level</h3>
                    </div>
                  </v-col>
                  <v-col cols="12" md="12" lg="8">
                    <div class="d-flex align-center justify-center">
                      <v-card class="section-phase inset-box-shadow rounded-lg py-4 mt-3" flat color="#F7F8F7" style="width:50%">
                        <section class="d-flex justify-center" style="width:100%">
                          <section class="d-flex justify-center" style="width: 70%">
                            <img
                              v-if="phase == 'endline'"
                              src="../../../../assets/img/radar/ScholarsLevelEndline.png"
                              width="100%"
                              alt=""
                              style="object-fit: contain;"
                            />
                            <img
                              v-else-if="phase == 'midline'"
                              src="../../../../assets/img/radar/Scholars LevelMidline.png"
                              width="100%"
                              alt=""
                              style="object-fit: contain;"
                            />
                            <img
                              v-else-if="phase == 'baseline'"
                              src="../../../../assets/img/radar/ScholarsLevelBaseline.png"
                              width="100%"
                              alt=""
                              style="object-fit: contain;"
                            />
                            <img
                              v-else
                              src="../../../../assets/img/radar/ScholarsLevelDefault.png"
                              width="100%"
                              alt=""
                              style="object-fit: contain;"
                            />
                          </section>
                        </section>
                        <section class="d-flex justify-center" style="width:100%">
                          <section
                            class="d-flex justify-space-between px-3"
                            style="width: 80%"
                          >
                            <div
                              :class="
                                phase == 'baseline'
                                  ? `d-flex justify-center font-weight-black`
                                  : `d-flex justify-center`
                              "
                            >
                              Baseline
                            </div>
                            <div
                              :class="
                                phase == 'midline'
                                  ? `d-flex justify-center font-weight-black`
                                  : `d-flex justify-center`
                              "
                            >
                              Midline
                            </div>
                            <div
                              :class="
                                phase == 'endline'
                                  ? `d-flex justify-center font-weight-black`
                                  : `d-flex justify-center`
                              "
                            >
                              Endline
                            </div>
                          </section>
                        </section>
                      </v-card>
                      <v-card class="hider-phase inset-box-shadow rounded-lg py-4 mt-3 text-center" flat color="#F7F8F7">
                          <h4>Your screen must be at least 350px wide to view the chart</h4>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!-- Values and Competency Score -->
            <div>
              <div class="d-flex mt-3">
                  <div class="score-scholar pa-3">
                    <v-card class="temp_radar pa-3 rounded-lg">
                      <div class="d-flex align-center mb-3">
                        <img
                          src="../../../../assets/img/radar/radarIcon.png"
                          height="35px"
                          alt=""
                        />
                        <h3>Values and Competency Score</h3>
                      </div>
                      <v-card
                        v-if="!loading"
                        class="bg-radar inset-box-shadow rounded-lg"
                        elevation="0"
                        color="#F7F8F7"
                      >
                      </v-card>
                      <div class="div-radar" id="radar"></div>
                      <div class="hider-radar inset-box-shadow rounded-lg text-center">
                          <h4>Your screen must be at least 625px wide to view the chart</h4>
                      </div>
                    </v-card>
                  </div>
                </div>
            </div>
          </v-card>

          <v-card class="rounded-lg pa-1" flat>
            <profile-calendar />
          </v-card>
        </div>
      </v-col>
      <!-- <v-col cols="12" md="4" lg="4">
        <div class="pa-2">
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <v-progress-circular
              size="100"
              width="20"
              :value="100"
              class="shadow_circular"
              color="#006341"
            ></v-progress-circular>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <v-progress-circular
              size="100"
              width="20"
              :value="83"
              class="shadow_circular"
              color="#001A72"
            ></v-progress-circular>
          </v-card>
          <v-card class="rounded-lg pa-3 mb-3" flat>
            <v-progress-circular
              size="100"
              width="20"
              :value="10"
              class="shadow_circular"
              color="#B3A369"
            ></v-progress-circular>
          </v-card>
        </div>
      </v-col> -->
    </v-row>

    <div class="pa-3">
      <view-announ
        :v_announ="v_announ"
        :inventory="inventory"
        @close="v_announ = false"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ProfileCalendar from "../profileCalendar.vue";
import MainProfileScholar from "../../../../components/profile/scholar/mainProfileScholar.vue";
import { mapState } from "vuex";
import ViewAnnoun from "../../../Announcement/viewAnnoun.vue";
export default {
  name: "dashboardProfileScholar",
  components: {
    apexchart: VueApexCharts,
    ProfileCalendar,
    MainProfileScholar,
    ViewAnnoun,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
      scholar: (state) => state.scholar,
    }),
  },
  data() {
    return {
      dataSet: [],
      model: 0,
      page: 1,
      limit: 10,
      announ: [],
      loading: false,
      v_announ: false,
      inventory: null,
      // radar
      phase: null,
      base: [],
      mid: [],
      end: [],
      labelBase: "",
      labelMid: "",
      labelEnd: "",
      categories: [],
    };
  },
  mounted() {
    // this.getAnounc();
    this.getGrafis(this.scholar);
  },
  methods: {
    getAnounc() {
      this.loading = true;
      let data = {
        path: `announcement/scholar`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.announ = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewAnouncement(item) {
      this.inventory = item;
      this.v_announ = true;
    },
    
    getGrafis(id_scholar) {
      this.loading = true;
      let data = {
        path: `scholar/statistic?scholar_id=` + id_scholar,
      };
      this.$store.dispatch("user/getUser", data).then((data) => {
        this.phase = data.fase_scholar;
        let result = data;
        let baseline = result.baseline;
        let midline = result.midline;
        let endline = result.endline;
        for (let key in baseline) {
            this.base.push(baseline[key]);
            this.categories.push(key.replace(/_/g, " "));
        }
        for (let key in midline) {
            this.mid.push(midline[key]);
            this.categories.push(key.replace(/_/g, " "));
        }
        for (let key in endline) {
            this.end.push(endline[key]);
            this.categories.push(key.replace(/_/g, " "));
        }
        setTimeout(() => {
          this.getRadar();
          this.loading = false;
        }, 100);
      });
    },
    getRadar() {
      let series = [
        {
          name: "Baseline",
          data: this.base,
        },
        {
          name: "Midline",
          data: this.mid,
        },
        {
          name: "Endline",
          data: this.end,
        },
      ];
      let options = {
        series: series,
        colors: ["#008448", "#BCA14A", "#5F99AA"],
        chart: {
          height: 500,
          type: "radar",
          toolbar: {
            show: false,
          },
        },
        legend: {
          position: "left",
          offsetY: 200,
          offsetX: 20,
          onItemClick: {
            toggleDataSeries: true,
          },
        },
        stroke: {
          width: 1,
        },
        fill: {
          opacity: 0.5,
        },
        markers: {
          size: 3,
          onClick: undefined,
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: [
          {
            tickAmount: 5,
            min: 0,
            max: 5,
          },
        ],
        responsive: [
          {
            breakpoint: 1000,
            options: {
              legend: {
                offsetY: -20,
                offsetX: 0,
                position: "bottom",
              }
            }
          }
        ]
      };

      var chart = new ApexCharts(document.querySelector("#radar"), options);
      chart.render();
    },
  },
};
</script>

<style scoped>
.bolder {
  font-weight: bold;
}
.desktop_profile {
  display: none;
  overflow: hidden;
}
@media (max-width: 724px) {
  .desktop_profile {
    display: block;
  }
}
.score-scholar {
  width: 100%;
}
.bg-radar {
  position: absolute;
  left: 2%;
  right: 2%;
  width: 96%;
  height:500px;
  bottom: 20px;
}
.inset-box-shadow {
  box-shadow: inset 0 2px 1px -1px rgba(0, 0, 0, 0.2),
    inset 0 1px 1px 0 rgba(0, 0, 0, 0.14), inset 0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}
.temp_radar {
  position: relative;
  height: 100%;
}
@media (min-width: 1265px) {
  .txt-current-phase{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
@media (max-width: 1264px) {
  .txt-current-phase{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
@media (min-width: 626px) {
  .div-radar {
    display: block;
  }
  .bg-radar {
    display: block;
  }
  .hider-radar {
    display: none;
  }
  .section-phase {
    display: block;
  }
  .hider-phase {
    display: none;
  }
}
@media (max-width: 625px) {
  .div-radar {
    display: none;
  }
  .bg-radar {
    display: none;
  }
  .hider-radar {
    padding: 10px;
    display: flex;
    height: 300px;
    background: #F7F8F7; 
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .section-phase {
    display: none;
  }
  .hider-phase { 
    padding: 10px;
    display: flex;
    background: #F7F8F7; 
    width: 100%;
    align-items: center;
    justify-content: center;
  }
}
</style>
